import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box, Grid, Typography, Card, CardContent, Button, Dialog, DialogTitle, DialogContent, DialogActions
} from '@mui/material';
import StarIcon from '@mui/icons-material/Star';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import SavingsIcon from '@mui/icons-material/Savings';
import MilitaryTechIcon from '@mui/icons-material/MilitaryTech';
import ContactPhoneIcon from '@mui/icons-material/ContactPhone';
import HeaderRecruteur from '../../header/headerRec';
import './Dashboard.css';
import MissionsList  from './MissionsList';
import Chatbox from '../../commun/ChatBox';
import PeopleIcon from '@mui/icons-material/People';
import AssignmentIcon from '@mui/icons-material/Assignment';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import Footer from '../../commun/Footer';
import LoadingPopup from "../../commun/LoadingPopup";

const MultiDeviseAmount = ({ montantObj }) => (
  <>
    {montantObj && Object.entries(montantObj).map(([devise, montant]) =>
      montant > 0 && (
        <Typography variant="h5" key={devise}>
          {montant.toLocaleString()} {devise}
        </Typography>
      )
    )}
  </>
);


const DashboardModern = () => {
  const API_BASE = process.env.REACT_APP_API_BASE_URL;
  const token = localStorage.getItem('authToken');
  const recruteurName = localStorage.getItem('recruteurName');
  const navigate = useNavigate();

  const [recruteurStats, setRecruteurStats] = useState(null);
  const [missions, setMissions] = useState([]);
  const [openPrime, setOpenPrime] = useState(false);
  const [openCagnotte, setOpenCagnotte] = useState(false);
  const [openNiveau, setOpenNiveau] = useState(false);

  useEffect(() => {
    fetch(`${API_BASE}/api/recruteur-stats`, {
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(res => res.json())
      .then(data => setRecruteurStats(data));

    fetch(`${API_BASE}/api/missions/all`)
      .then(res => res.json())
      .then(data => {
        if (Array.isArray(data)) {
          const activeMissions = data.filter(m => m.status === 'active'); 
          setMissions(activeMissions.slice(0, 4));
        } else {
          setMissions([]);
        }
      });
 }, []);

  const getStarsCount = (niveau) => {
  const norm = (niveau?.toLowerCase?.()) || 'débutant';
    if (norm === 'intermédiaire') return 2;
    if (norm === 'confirmé') return 3;
    if (norm === 'expert') return 4;
    if (norm === 'légende') return 5;
    return 1;
  };

  if (!recruteurStats) return 
    <LoadingPopup
        open={!recruteurStats}
        message=""
      />
  ;

  const statsData = [
    {
      label: 'Missions prises',
      value: recruteurStats.missionsPrises,
      className: 'stat-missions',
      icon: <AssignmentIcon className="stat-badge-icon" />,
    },
    {
      label: 'Candidatures en cours',
      value: recruteurStats.candidaturesPresentees,
      className: 'stat-candidats',
      icon: <PeopleIcon className="stat-badge-icon" />,
    },
    {
      label: 'En entretien',
      value: recruteurStats.enEntretien,
      className: 'stat-entretiens',
      icon: <ThumbUpIcon className="stat-badge-icon" />,
    },
    {
      label: 'Recrutées',
      value: recruteurStats.recrutes,
      className: 'stat-recrutes',
      icon: <CheckCircleIcon className="stat-badge-icon" />,
    },
  ];

  return (
    <Box>
      <HeaderRecruteur recruteurName={recruteurName} />
      <Box className="dashboard-container">
        <div className="dashboard-flex">

          {/* Bloc gauche : Stats + Missions */}
          <div className="dashboard-rec">
            <Typography variant="h5" mb={2}>Statistiques</Typography>
            <div className="stats-badge-flex">
              {statsData.map((stat, i) => (
                <div className={`stat-badge-flat ${stat.className}`} key={i}>
                  <span className="stat-badge-icon">{stat.icon}</span>
                  <span className="stat-badge-content">
                    <span className="stat-badge-label">{stat.label}</span>
                    <span className="stat-badge-value">{stat.value || 0}</span>
                  </span>
                </div>
              ))}
            </div>
            <Typography variant="h6" gutterBottom>Dernières missions</Typography>
            <MissionsList
              missions={missions}
              onView={id => navigate(`/Recruteur/Details/${id}`)}
            />
          </div>

          {/* Bloc droit vertical */}
          <div className="dashboard-side-vertical">
            {/* Niveau */}
            <Card className="dashboard-side-card niveau-card-modern">
              <div className="side-icon-wrap" style={{ background: "#c3dafe" }}>
                <MilitaryTechIcon className="side-card-icon" style={{ color: "#2d4a87" }} />
              </div>
              <CardContent>
                <div className="side-card-label">Vous êtes</div>
                <div className="side-card-value niveau-label-modern">{recruteurStats.niveau?.label || 'Débutant'}</div>
                <div className="niveau-stars">
                  {[...Array(5)].map((_, i) => (
                    <StarIcon
                      key={i}
                      className={i < getStarsCount(recruteurStats.niveau?.label) ? "star-yellow" : "star-grey"}
                    />
                  ))}
                </div>
                <Button
                  onClick={() => setOpenNiveau(true)}
                  size="small"
                  variant="outlined"
                  className="side-card-btn"
                >EN SAVOIR PLUS</Button>
              </CardContent>
            </Card>
            {/* Cagnotte */}
            <Card className="dashboard-side-card cagnotte-card-modern">
              <div className="side-icon-wrap" style={{ background: "#d1f6ec" }}>
                <SavingsIcon className="side-card-icon" style={{ color: "#16a085" }} />
              </div>
              <CardContent>
                <div className="side-card-label">Ma cagnotte</div>
                <div className="side-card-value">
                  <MultiDeviseAmount montantObj={recruteurStats.cagnotte} />
                </div>
                <div className="side-card-desc">Montant disponible pour retrait</div>
                <Button
                  onClick={() => setOpenCagnotte(true)}
                  size="small"
                  variant="outlined"
                  className="side-card-btn"
                >En savoir plus</Button>
              </CardContent>
            </Card>
            {/* Prime estimée */}
            <Card className="dashboard-side-card prime-card-modern">
              <div className="side-icon-wrap" style={{ background: "#ede7f6" }}>
                <MonetizationOnIcon className="side-card-icon" style={{ color: "#7c4dff" }} />
              </div>
              <CardContent>
                <div className="side-card-label">Prime estimée</div>
                <div className="side-card-value">
                  <MultiDeviseAmount montantObj={recruteurStats.primeTotale} />
                </div>
                <div className="side-card-desc">Cumulé sur vos profils présentés</div>
                <Button
                  onClick={() => setOpenPrime(true)}
                  size="small"
                  variant="outlined"
                  className="side-card-btn"
                >En savoir plus</Button>
              </CardContent>
            </Card>
            {/* Contact 
            <Card className="dashboard-side-card contact-card-modern">
              <div className="side-icon-wrap" style={{ background: "#ffe082" }}>
                <ContactPhoneIcon className="side-card-icon" style={{ color: "#bfa800" }} />
              </div>
              <CardContent>
                <div className="side-card-label">Votre contact Cooptaleo</div>
                <div className="side-contact-name">Nom prénom</div>
                <div className="side-contact-role">Responsable</div>
                <div className="side-contact-coords">
                  <a href="tel:+33612345678" className="contact-link">+33 6 12 34 56 78</a><br />
                  <a href="mailto:contact@cooptaleo.com" className="contact-link">contact@cooptaleo.com</a>
                </div>
              </CardContent>
            </Card> */}
          </div>
        </div>

        {/* Modales */}
        <Dialog open={openPrime} onClose={() => setOpenPrime(false)} maxWidth="sm" fullWidth>
          <DialogTitle>💰 Prime estimée</DialogTitle>
          <DialogContent dividers>
            <Typography>
              La prime estimée correspond au cumul des primes sur toutes les missions
              pour lesquelles vous avez soumis des profils (toutes devises confondues). Cela représente une estimation, avant validation du recrutement.
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setOpenPrime(false)}>Fermer</Button>
          </DialogActions>
        </Dialog>

        <Dialog open={openCagnotte} onClose={() => setOpenCagnotte(false)} maxWidth="sm" fullWidth>
          <DialogTitle>💼 Ma cagnotte</DialogTitle>
          <DialogContent dividers>
            <Typography>
              Votre cagnotte représente la somme réellement obtenue pour les profils
              que vous avez proposés et qui ont été recrutés, séparée par devise. Ce montant est disponible pour retrait selon les conditions de la plateforme.
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setOpenCagnotte(false)}>Fermer</Button>
          </DialogActions>
        </Dialog>

        <Dialog open={openNiveau} onClose={() => setOpenNiveau(false)} maxWidth="sm" fullWidth>
          <DialogTitle>⭐ Niveaux & réputation</DialogTitle>
          <DialogContent dividers>
            <Typography gutterBottom>
              Votre niveau indique votre engagement sur la plateforme :
            </Typography>
            <ul>
              <li><strong>Débutant</strong> : Aucun profil recruté. Merci de poursuivre vos efforts !</li>
              <li><strong>Intermédiaire</strong> : 2 profils recrutés.</li>
              <li><strong>Confirmé</strong> : 4 profils recrutés.</li>
              <li><strong>Expert</strong> : 6 profils recrutés.</li>
              <li><strong>Légende</strong> : 10 profils recrutés ou plus.</li>
            </ul>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setOpenNiveau(false)}>Fermer</Button>
          </DialogActions>
        </Dialog>
      </Box>
      <Chatbox userRole="recruteur" />

       <Footer />
    </Box>

  );
};

export default DashboardModern;
